import { defineStore } from 'pinia';
import { useHttp } from '@/http/http';
import { statusCheck } from '@/store/public'; // 檢查 API 響應狀態的函數
import Swal from 'sweetalert2';

//此pinia用於new bank transfer按鈕
export const useBankStore = defineStore('bank', {
  state: () => ({
    driverIds: [], // 所有司机 ID
    selectedDriverIds: [], // 已选择的司机 ID
    totalEntries: 0,
    currentPage: 1,
    itemsPerPage: 10,
    fromDate: '',
    toDate: '',
    driverTransactions: [], // 所有司機的交易數據
    selectedTransactionIds: [], // 选择的交易 ID
    totalAmount: 0, // 总金额
    totalTransactions: 0, // 总交易数
    fees_and_refunds: 0, // 费用和退款
    currentPageTransactions: 1,
    itemsPerPageTransactions: 10,
    pageSizeOptions: [10, 20, 50, 100],
    totalTransactionEntries: 0, // 總交易數
    filters: {
    },
  }),
  actions: {
    async fetchDriverIds(driver_id = '') {
      const url = `/api/admin/payment/driver_ids?driver_id=${driver_id}`;
      try {
        const response = await useHttp().get(url);
        this.driverIds = response.data.driver_ids;
        this.totalEntries = this.driverIds.length;
      } catch (error) {
        console.error('Error fetching driver IDs:', error);
        throw error;
      }
    },
    async fetchDriverTransactions() {
      const url = '/api/admin/payment/drivers_transactions';
      const payload = {
        driver_ids: this.selectedDriverIds,
        from: this.fromDate,
        to: this.toDate,
      };
      try {
        const response = await useHttp().post(url, payload);
        this.driverTransactions = response.data.data.transactions ? response.data.data.transactions : [];
        this.fees_and_refunds = response.data.data.fees_and_refunds;
        this.totalTransactionEntries = response.data.data.total_count; // 設置總交易數
      } catch (error) {
        console.error('Error fetching driver transactions:', error);
        throw error;
      }
    },
    async createBankTransfer() {
      const url = '/api/admin/payment/create_bank_transfer';
      const payload = {
        transaction_ids: this.selectedTransactionIds,
        driver_ids: this.selectedDriverIds,
      };
      try {
        const response = await useHttp().post(url, payload);
        if (statusCheck(response.data)) {
            Swal.fire({
              icon: 'success',
              title: 'Bank transfer created successfully!',
              showConfirmButton: false,
              timer: 1500,
          });
          return response.data;
        }
      } catch (error) {
        console.error('Error creating bank transfer:', error);
        throw error;
      }
    },
    changeTransactionPage(page) {
      if (page >= 1 && page <= this.totalTransactionPages) {
        this.currentPageTransactions = page;
      }
    },
  },
  getters: {
    // 分頁後的交易數據
    paginatedTransactions(state) {
      const startIndex = (state.currentPageTransactions - 1) * state.itemsPerPageTransactions;
      const endIndex = startIndex + state.itemsPerPageTransactions;
      return state.driverTransactions.slice(startIndex, endIndex);
    },
    // 總交易頁數
    totalTransactionPages(state) {
      return Math.ceil(state.totalTransactionEntries / state.itemsPerPageTransactions);
    },
  },
});
